<template>
  <div style="padding-bottom:15px;">
  <div style="max-height: 300px;overflow:auto;">
    <el-radio-group v-model="position" >

      <el-radio
        v-for="i in postions"
        :label="i.name"
        :key="i.id"
        style="display: block;margin-left: 50px;height: 30px;line-height:30px;font-size: 16px;font-weight: normal"
      >{{i.name}}</el-radio>

    </el-radio-group>
  </div>

  <div slot="footer" class="dialog-footer" style="text-align: right; margin-top:15px;">
    <el-button type="primary" @click="canclePost">取 消</el-button>
    <el-button type="primary" @click="confirmPost">确 定</el-button>
  </div>

  </div>
</template>
<script>
    export default {

        data() {
            return {
              position: '',
              postions: [{
                'id': 1,
                'name': '公司领导'
              },
                {'id': 2, 'name': '党组书记'},
                {'id': 3, 'name': '总经理'},
                {'id': 4, 'name': '副总经理'}, {'id': 5, 'name': '主任'},
                {'id': 6, 'name': '副主任'}, {'id': 7, 'name': '处长'},
                {'id': 8, 'name': '副处长'}, {'id': 9, 'name': '总监'}
              ],
            }
        },
      methods:{
        confirmPost(){
          this.$emit("confirm",this.position);
        },
        canclePost(){
          this.$emit("cancel");
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user/choosePost.vue